import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'

export default ( {fail=false} ) => {
    let message = ''
    if (!fail) {message = <FormattedHTMLMessage id='bid.bid_sent'/>}
    else {message = <FormattedHTMLMessage id='bid.bid_fail'/>}
    return (
        <div className='Container'>
            <div className='NotFound'>
                <div className='NotFound__body'>
                    <p className='NotFound__caption'>
                        {message}
                    </p>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/containers/PayNotification.jsx